import { useContext } from 'react';
import {
  useDataModel,
  params,
  string,
  bool
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';

import { isNIncluded, validateNValue, isRefinedPage, getPathName } from '../utils/searchHelpers';

export const useHybridData = ({ isShowProducts, navParam, isSearch, isSkip }) => {
  const { path, customer } = useContext(ExperienceContext);

  const slugData = isNIncluded(navParam) ? navParam : `N-${navParam}`;

  const pathname = getPathName(path ?? '');
  const layoutOptions = {
    variables: {
      slug: isShowProducts ? slugData + '-ShowProducts' : slugData,
      isHybrid: validateNValue(slugData),
      customerType: customer?.type,
    },
    ssr: true,
    skip: isSkip || isSearch || isRefinedPage(pathname) || !navParam
  };
  const { data: hybridData, loading: hybridLoading } = useDataModel('layouts', layoutOptions);

  const layouts = hybridData?.layouts;
  const layoutID = layouts?.id;
  const isHybridLayout = !!layoutID && layouts?.content?.__typename === 'HybridPLPLayout';
  const isBrandPage = layouts?.content?.pageType === 'Brand Page';

  return {
    isHybridLayout,
    isBrandPage,
    hybridLoading,
    hybridLayoutID: layoutID ?? ''
  };
};

useHybridData.dataModel = {
  layouts: params({
    slug: string().isRequired(),
    customerType: string(),
    isHybrid: bool()
  }).shape({
    id: string(),
    slug: string(),
    type: string(),
    title: string()
  })
};
